// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3ZdSs","label":"Category_label__13WVZ","content":"Category_content__35hR7","header":"Category_header__14nlm","location":"Category_location__36PRG"};